/**
 * @file  Image/style.ts
 * @description  default image styles
 *
 * @example <Link  />
 *
 * @author ogarcia (ozkary)
 *
 */
import styled from 'styled-components';

// style props
export interface Props {
  src: string;
  width?: string;
  height?: string;
  title: string;
  className?: string;
}

export const Image = styled.img<Props>`
    src={src}
    alt={title}
    className={className}
    width={width}
    height={height}
    aria-label: {title}
    className: ${(props) => props.className || ''};
`;
